import React from 'react';
import { BookOpen, ExternalLink, CheckCircle } from 'lucide-react';
import type { StrategyExtractionData } from '../../types/expert';

interface StrategyCardProps {
  data: StrategyExtractionData;
}

const StrategyCard: React.FC<StrategyCardProps> = ({ data }) => {
  return (
    <div className="rounded-xl border border-purple-500/20 bg-slate-800/80 p-4">
      {/* Header */}
      <div className="flex items-center gap-2 mb-3">
        <CheckCircle size={16} className="text-emerald-400" />
        <span className="text-sm font-semibold text-slate-200">
          Strategy Extracted
        </span>
        {data.pipeline && (
          <span className="ml-auto text-[10px] px-1.5 py-0.5 bg-purple-500/10 text-purple-300 rounded">
            {data.pipeline}
          </span>
        )}
      </div>

      {/* Strategy name */}
      <div className="mb-3">
        <div className="flex items-center gap-2">
          <BookOpen size={14} className="text-purple-400 shrink-0" />
          <p className="text-base font-bold text-white truncate">
            {data.strategyName}
          </p>
        </div>
        {data.videoTitle && data.videoTitle !== data.strategyName && (
          <p className="text-xs text-slate-400 mt-1 truncate">
            From: {data.videoTitle}
          </p>
        )}
      </div>

      {/* Content preview */}
      {data.content && (
        <p className="text-xs text-slate-300 leading-relaxed line-clamp-4 mb-3">
          {data.content}
        </p>
      )}

      {/* Footer */}
      <div className="flex items-center justify-between">
        <span className="text-xs text-slate-500">
          {data.message || 'Saved to your strategy library'}
        </span>
        {data.sourceUrl && (
          <a
            href={data.sourceUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-purple-400 hover:text-purple-300 flex items-center gap-1"
          >
            Source <ExternalLink size={10} />
          </a>
        )}
      </div>
    </div>
  );
};

export default StrategyCard;
